import React from 'react';
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import { FiCheck } from "react-icons/fi";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ContactOne from "../elements/contact/ContactOne";
import ScrollAnimation from "react-animate-on-scroll";


const MemAssociates = () => {
    return (
        <>
            <SEO title="Events" />
            <Layout>
                <BreadcrumbOne 
                    title="Membership for Associates"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Membership for Associates"
                />
                 <div className="row row--30 mt--30" style={{padding:"30px"}}>
            <div className="col-lg-6 col-md-5 col-sm-4 col-12 bg-color-white radius">
            <div className="split-inner" style={{padding:"30px"}}>
            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">UFTAA welcomes organizations; federations; tourism boards; authorities to join UFTAA as Institutional members. A number of travel & tourism related organizations can benefit from UFTAA membership since this is one easy way to get connected with our membership - associations and affiliates. These institutional members can promote tourism and travel related and allied products through channels that can strengthen their presence, globally or even get connected with offering partnership opportunities with our membership. In a fast evolving market place, such organizations presence in UFTAA can make a positive impact. With UFTAA, there can be ways to identify strategies to add to good health of the industry. </p>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <h6 style={{fontsize:"20px"}}>Types of institutional members can be:</h6>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                 <ul className="feature-list">
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Tourism Boards (Domestic or International)   Destination consultants/ representatives</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">Cruise-lines organizations/ owners</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> 	Aviation / Air Charter Companies   Hotel Chains with Global presence</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Railways</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Health Centers (for fostering medical tourism)</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Theme Parks/ Tourism Centers</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Large wellness centers/companies with global presence </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">  	Other Federations of Associations or Associations promoting MICE; Tourism; Transport; Freight; Education </p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">  	Insurance Companies/ organizations </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">  Manpower training/ educational organizations (large ones) </p>
                                        </div>
                                    </li>
                                </ul>
                            </ScrollAnimation>
                          
                        </div>
            </div>
            <div className="col-lg-6 col-md-5 col-sm-4 col-12 bg-color-white radius" style={{padding:"30px"}}>
            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                            <h5 style={{fontsize:"30px", fontWeight:"bold"}}>Annual Fees</h5>

                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">Annual Membership fee for Institutional Members. (TWO UFTAA ID Cards with our compliments - for anytwo nominees of the Applicant) </p>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                            <h6 style={{fontsize:"30px", fontWeight:"bold"}}>One time Admission Fee of € 500</h6>
                            <h6 style={{fontsize:"30px", fontWeight:"bold"}}>Minimum Annual Fee : € 1000 (the fee may be more for large organizations as determined by the UFTAA Board - once the application is submitted, on its consideration, depending on the size of the applicant, the fees determined will be communicated)</h6>

                            </ScrollAnimation>
                            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScZe-jNXB2Nyo-yaUgKt0IARxSjhTC4XnE0JmbLiAgyKix0hA/viewform?embedded=true" width="640" height="1236" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </div>
            </div>
            
        </Layout>
        </>
    )
}
export default MemAssociates;